import { z } from 'zod'

const envSchema = z.object({
    API_URL: z.string().url(),
    BASE_URL: z.string().url(),
    REALM: z.string(),
    RESOURCE_REALM: z.string(),
    AUTH_SERVER_ROOT: z.string().url(),
    DEBUG: z.string().transform((val) => val === 'true'),
    MAIN_REJESTR_API_SHORT: z.string(),
    MAIN_REJESTR_API_LONG: z.string(),
    MAIN_REJESTR_LANG1: z.string(),
    AI_CHAT_API_URL: z.string().url(),
})

// Use Vite's import.meta.env for environment variables
const envVars = {
    API_URL: import.meta.env.VITE_API_URL,
    BASE_URL: import.meta.env.VITE_BASE_URL,
    REALM: import.meta.env.VITE_REALM,
    RESOURCE_REALM: import.meta.env.VITE_RESOURCE_REALM,
    AUTH_SERVER_ROOT: import.meta.env.VITE_AUTH_SERVER_ROOT,
    DEBUG: import.meta.env.VITE_DEBUG,
    MAIN_REJESTR_API_SHORT: import.meta.env.VITE_MAIN_REJESTR_API_SHORT,
    MAIN_REJESTR_API_LONG: import.meta.env.VITE_MAIN_REJESTR_API_LONG,
    MAIN_REJESTR_LANG1: import.meta.env.VITE_MAIN_REJESTR_LANG1,
    AI_CHAT_API_URL: import.meta.env.VITE_AI_CHAT_API_URL,
}

const parsedEnv = envSchema.safeParse(envVars)

if (!parsedEnv.success) {
    console.error('❌ Environment validation failed:')
    console.error(parsedEnv.error.format())
    throw new Error('Environment configuration is invalid')
}

console.log('✅ Environment variables validated successfully!')
export const env = parsedEnv.data
